import { ThemeProvider as NextThemeProvider } from 'next-themes'
import { GrafbaseThemes, darkTheme } from 'style'

import { FCC } from 'types/react'

export const ThemesProvider: FCC = ({ children }) => (
  <NextThemeProvider
    attribute="class"
    defaultTheme="system"
    disableTransitionOnChange
    storageKey="grafbase-theme"
    value={{
      light: GrafbaseThemes.light,
      dark: darkTheme.className,
    }}
  >
    {children}
  </NextThemeProvider>
)
